import { render } from "./widget-balance-main.vue?vue&type=template&id=03eac141&scoped=true"
import script from "./widget-balance-main.vue?vue&type=script&lang=js"
export * from "./widget-balance-main.vue?vue&type=script&lang=js"

import "./widget-balance-main.vue?vue&type=style&index=0&id=03eac141&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03eac141"]])

export default __exports__